/* shadcn 커스텀 컴포넌트 - button 수정 컴포넌트 ( 기본 shadcn 버튼에 있는 스타일 제거 ) */

import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/shared/shadcn/lib/utils';

import { forwardRef } from 'react';

export default forwardRef(function CustomButton(
  {
    className,
    onClick,
    asChild = false,
    ...props
  }: React.ComponentProps<'button'> & {
    asChild?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  },
  ref: React.Ref<HTMLButtonElement>
) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      ref={ref}
      data-slot='button'
      className={cn(className, 'tw-btn')}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      {...props}
    />
  );
});
